import Vue from 'vue'
import VueRouter from 'vue-router'
import Cookie from "js-cookie";
// import home from '../views/home'
import pages from './pages'
import staticRouter from './staticRouter'
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

// function loadPage() {
// 	var data = [{
// 			path: '/',
// 			name: 'login',
// 			component: () => import('@/views/login')
// 		},
// 		{
// 			path: '/home',
// 			name: 'home',
// 			component: () => import('@/views/home')
// 		},
// 		{
// 			path: '/aEventEnter', // 事件接报录入
// 			name: 'aEventEnter',
// 			component: () => import('@/components/event/aEventEnter')
// 		},
// 		{
// 			path: '/bEventAnalysis', // 事件研判分析
// 			name: 'bEventAnalysis',
// 			component: () => import('@/components/event/bEventAnalysis')
// 		},
// 		{
// 			path: '/cEventResources', // 匹配相关资源
// 			name: 'cEventResources',
// 			component: () => import('@/components/event/cEventResources')
// 		},
// 		{
// 			path: '/dEventDispatch', // 资源调度
// 			name: 'dEventDispatch',
// 			component: () => import('@/components/event/dEventDispatch')
// 		},
// 		{
// 			path: '/eEventReport', // 事件处置完毕报告
// 			name: 'eEventReport',
// 			component: () => import('@/components/event/eEventReport')
// 		},


// 		{
// 			path: '/aRecord', // 记录
// 			name: 'aRecord',
// 			component: () => import('@/components/eventRecord/aRecord')
// 		},
// 		{
// 			path: '/bRecord', // 记录
// 			name: 'bRecord',
// 			component: () => import('@/components/eventRecord/bRecord')
// 		},
// 		{
// 			path: '/cRecord', // 记录
// 			name: 'cRecord',
// 			component: () => import('@/components/eventRecord/cRecord')
// 		},
// 		{
// 			path: '/dRecord', // 记录
// 			name: 'dRecord',
// 			component: () => import('@/components/eventRecord/dRecord')
// 		},
// 		{
// 			path: '/eRecord', // 记录
// 			name: 'eRecord',
// 			component: () => import('@/components/eventRecord/eRecord')
// 		},
// 		// {
// 		//   path: '/home/population',
// 		//   name: 'population',
// 		//   component: () => import('@/views/home/population')
// 		// },
// 		// {
// 		//   path: '/home/peopleStatistics',
// 		//   name: 'peopleStatistics',
// 		//   component: () => import('@/views/home/peopleStatistics')
// 		// },

// 	]


// 	// const token = localStorage.getItem("token")
// 	// if (token) {
// 	/* pages.pages.forEach((item, index) => {
// 	  if (item.children && item.children.length > 0) {
// 	    item.children.forEach(val => {
// 	      data.push({
// 	        path: '/' + val.strUrl,
// 	        name: val.routeName,
// 	        component: () => import('@/views/' + item.routeName + '/' + val.strUrl)
// 	      })
// 	    })
// 	  }else{
// 	    data.push({
// 	      path: '/' + item.strUrl,
// 	      name: item.routeName,
// 	      component: () => import('@/views/' + item.routeName)
// 	    })
// 	  }
// 	}) */
// 	// }


// 	data.push({
// 		path: '/401',
// 		name: 'error_401',
// 		meta: {
// 			show: false
// 		},
// 		component: () => import('@/components/common/errorPage/401.vue')
// 	}, {
// 		path: '/500',
// 		name: 'error_500',
// 		meta: {
// 			show: false
// 		},
// 		component: () => import('@/components/common/errorPage/500.vue')
// 	}, {
// 		path: '*',
// 		name: 'error_404',
// 		meta: {
// 			show: false
// 		},
// 		component: () => import('@/components/common/errorPage/404.vue')
// 	}, )

// 	return data


// }

// const routes = loadPage()
const routes = staticRouter

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes
})

// 路由拦截器
router.beforeEach((to, from, next) => {
	console.log(to)
	if (to.query.token) {
		localStorage.setItem('token',to.query.token)
		console.log('111');
		next()
	} else {
		const token = localStorage.getItem('token')
		// 去登录
		if (to.name == 'login') {
			next()
		}
		// 没有 token 并且不是去 登录
		if (!token && to.name !== 'login') {
			next('/')
		} else {
			next()
		}
	}

})
export default router
